var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useFormState, useWatch } from 'react-hook-form';
import { ShopItem } from './shop-item';
import { useDebouncedCallback } from '../../../infra/small-tools/use-debounced-callback';
import { schema } from './use-shop-assignment-form';
import { useToggle } from '../../../infra/small-tools/use-toggle';
export var ShopItemContainer = function (props) {
    var _a, _b;
    var busy = useToggle(false);
    var formValues = useWatch({
        control: props.form.control,
        name: props.shop.id,
    });
    var formState = useFormState({
        name: props.shop.id,
        control: props.form.control,
    });
    var _c = useDebouncedCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    busy.setOn();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, props.updateShopTaxAssignment(props.shop, values)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    busy.setOff();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, 500, [props.updateShopTaxAssignment]), updateTax = _c.func, cancelTaxUpdate = _c.cancel;
    useEffect(function () {
        var _a;
        var error = schema.validate((_a = {}, _a[props.shop.id] = formValues, _a)).error;
        var isRowDirty = !!formState.touchedFields[props.shop.id] || !!formState.dirtyFields[props.shop.id];
        if (error) {
            cancelTaxUpdate();
        }
        if (!error && isRowDirty) {
            updateTax(formValues);
        }
    }, [formValues.percentage, formValues.enabled, formState.dirtyFields]);
    var errors = (_a = formState.errors) === null || _a === void 0 ? void 0 : _a[props.shop.id];
    return (_jsx(ShopItem, { busy: busy.isOn, shop: props.shop, form: props.form, readonly: props.disabled || busy.isOn, enabled: formValues.enabled, percentageErrorMsg: (_b = errors === null || errors === void 0 ? void 0 : errors.percentage) === null || _b === void 0 ? void 0 : _b.message }));
};
